import React from 'react';

interface CloseIconProps {
  height?: number;
  className?: string;
}

/**
 * Close's interlocking rings.
 *
 * The artwork is 64x60, so only `height` is set and the width follows from the
 * viewBox — forcing a square would letterbox the mark inside its own box.
 *
 * The source export wrapped everything in a `clipPath` whose rect covered the
 * whole canvas; it clipped nothing (the drawn bounds are 0..64 x 0.93..59.07)
 * and has been dropped, which also keeps this icon free of the per-instance id
 * scoping that a real `<clipPath>`/`<mask>` would need.
 */
export const CloseLogo: React.FC<CloseIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      viewBox="0 0 64 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M32 47C14.06 47 0 39.53 0 30C0 20.47 14.06 13 32 13C49.94 13 64 20.47 64 30C64 39.53 49.94 47 32 47ZM32 18C19.23 18 5 22.93 5 30C5 37.07 19.23 42 32 42C44.77 42 59 37.07 59 30C59 22.93 44.77 18 32 18Z"
        fill="#4EC375"
      />
      <path
        d="M42.83 59.04C34.81 59.04 24.55 51.11 17.27 38.5C13.14 31.35 10.63 23.8 10.19 17.23C9.71 10.03 11.77 4.73 15.99 2.29C20.21 -0.150004 25.84 0.719996 31.83 4.73C37.3 8.4 42.58 14.35 46.71 21.5C55.68 37.04 56.24 52.95 47.99 57.71C46.43 58.61 44.69 59.04 42.82 59.04H42.83ZM21.25 5.94C20.21 5.94 19.28 6.16 18.5 6.62C16.05 8.03 14.84 11.78 15.18 16.9C15.57 22.72 17.85 29.51 21.6 36.01C27.98 47.07 39.37 56.93 45.49 53.39C51.61 49.85 48.77 35.07 42.38 24.01C38.63 17.51 33.89 12.14 29.05 8.9C26.15 6.96 23.45 5.96 21.24 5.96L21.25 5.94Z"
        fill="#1463FF"
      />
      <path
        d="M21.24 59.07C19.33 59.07 17.57 58.62 16 57.71C11.78 55.27 9.71001 49.97 10.2 42.77C10.64 36.2 13.15 28.65 17.28 21.5C26.25 5.96 39.75 -2.48 48 2.29C56.25 7.06 55.69 22.96 46.72 38.5C42.59 45.65 37.31 51.6 31.84 55.27C28.08 57.79 24.46 59.07 21.24 59.07ZM42.62 5.89C36.26 5.89 27.09 14.5 21.6 24C17.85 30.5 15.57 37.28 15.18 43.11C14.84 48.23 16.05 51.97 18.5 53.39C20.95 54.8 24.79 53.98 29.06 51.12C33.91 47.87 38.64 42.5 42.39 36.01C48.77 24.95 51.62 10.16 45.5 6.63C44.64 6.13 43.67 5.9 42.62 5.9V5.89Z"
        fill="#FFBC00"
      />
      <path
        d="M32 42C19.23 42 5 37.07 5 30H0C0 39.53 14.06 47 32 47V42Z"
        fill="#4EC375"
      />
      <path
        d="M33.15 12.15C31.81 10.91 30.44 9.81 29.06 8.88C27.7 7.97 26.38 7.26 25.14 6.77L26.8 2.05C28.44 2.68 30.13 3.57 31.85 4.73C33.66 5.95 35.46 7.41 37.2 9.09L33.16 12.15H33.15Z"
        fill="#1463FF"
      />
      <path
        d="M37.16 52.48C35 51.32 32.75 49.59 30.57 47.5L26.74 50.83C28.98 53 31.28 54.78 33.56 56.12L37.17 52.48H37.16Z"
        fill="#1463FF"
      />
      <path
        d="M55.04 23.89C49.92 20.25 40.63 18 32 18V13C42.05 13 50.88 15.34 56.71 19.08L55.04 23.89Z"
        fill="#4EC375"
      />
    </svg>
  );
};
